// extracted by mini-css-extract-plugin
module.exports = {"unresolvedComponent":"UnresolvedComponent_unresolvedComponent__t0V1e"};